// Object.entries polyfill
if (!Object.entries) {
  Object.entries = function(obj) {
    if (obj == null) {
      throw new TypeError('Object.entries called on null or undefined');
    }
    
    var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i);
    
    while (i--)
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    
    return resArray;
  };
}

export default Object.entries;
